import { BookablesByDate } from '../../models/Bookable'
import { CalendarFilter } from '../../models/CalendarFilter'
import { User } from '../../models/User'
import Card from '../app/design/Card'
import { CalendarBookableTable } from './CalendarBookableTable'
import { CalendarEmptyState } from './CalendarEmptyState'

type Props = {
    heightOffset: number
    pros: User[]
    filter: CalendarFilter
    searchResults: BookablesByDate
}

export const CalendarSearch = ({ heightOffset, pros, filter, searchResults }: Props) => (
    <Card
        className="mt-6 mb-8 overflow-x-clip overflow-y-auto overscroll-contain"
        style={{
            maxHeight: `calc(100% - ${heightOffset}px)`,
            maxWidth: '100%',
            minWidth: '1024px',
        }}
    >
        <CalendarBookableTable
            bookablesByDate={searchResults}
            pros={pros}
            emptyState={
                <CalendarEmptyState
                    src={'/icons/bug-fixing-1.svg'}
                    title="No results"
                    subtitle={`Try again with ${!filter.isEmpty ? 'different filters or' : ''} a different search`}
                />
            }
        />
    </Card>
)
